const IconClinical = () => (
  <svg
    width="27px"
    height="32px"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.65 13.203a1.5 1.5 0 0 1-.512-2.06l5.998-9.96a1.5 1.5 0 0 1 2.059-.51l2.57 1.547a1.5 1.5 0 0 1 .511 2.06l-2.8 4.65c1.332.245 2.646.719 3.885 1.434 5.832 3.367 7.83 10.825 4.463 16.657-3.367 5.833-10.824 7.83-16.657 4.464a12.185 12.185 0 0 1-6.083-9.963l.124-.006L.703 20.07a1.125 1.125 0 0 1 1.125-1.949l9.571 5.526a1.125 1.125 0 1 1-1.125 1.949l-3.876-2.238a9.163 9.163 0 0 0 4.27 5.529 9.194 9.194 0 0 0 9.193-15.925 9.152 9.152 0 0 0-4.08-1.22l-1.503 2.497a1.5 1.5 0 0 1-2.058.511l-2.57-1.547Z"
      fill="#fff"
    />
    <path
      d="M10.72 17.357a1.643 1.643 0 1 1-2.846-1.642 1.643 1.643 0 0 1 2.845 1.642Z"
      fill="#fff"
    />
  </svg>
);

export default IconClinical;
